import React from "react";
import { useLang } from "../../context/LanguageContext";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1598139384902-5a8217874645?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

export default function About() {
  const { t } = useLang();
  return (
    <section
      id="about"
      data-testid="about-section"
      className="bg-cream-100 text-ink-800"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 py-24 md:py-32">
        <div className="grid md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-5 lg:col-span-4">
            <div className="font-mono text-xs uppercase tracking-[0.3em] text-ink-500 mb-6">
              {t.about.overline}
            </div>
            <div
              data-testid="about-kicker"
              className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[0.95] tracking-tight text-ink-800"
            >
              {t.about.kicker}
            </div>
            <div className="mt-10 hidden md:block">
              <img
                src={ABOUT_IMG}
                alt=""
                className="w-full aspect-[4/5] object-cover grayscale hover:grayscale-0 transition-all duration-700"
              />
            </div>
          </div>

          <div className="md:col-span-7 lg:col-span-7 lg:col-start-6">
            <h2
              data-testid="about-title"
              className="font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-tight text-ink-800 text-balance"
            >
              {t.about.title}
            </h2>
            <div className="mt-10 space-y-6 text-base md:text-lg leading-relaxed text-ink-500 max-w-2xl">
              <p>{t.about.p1}</p>
              <p>{t.about.p2}</p>
            </div>

            <div className="mt-14 grid grid-cols-3 gap-px bg-ink-800/15 border border-ink-800/15">
              {t.about.stats.map((s, i) => (
                <div
                  key={i}
                  data-testid={`about-stat-${i}`}
                  className="bg-cream-100 p-6 md:p-8"
                >
                  <div className="font-serif text-3xl md:text-5xl text-ink-800">
                    {s.value}
                  </div>
                  <div className="mt-2 font-mono text-[10px] md:text-xs uppercase tracking-[0.2em] text-ink-500">
                    {s.label}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
